var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "lisProject-edit" } },
    [
      _c(
        "IForm",
        {
          ref: "formInline",
          attrs: {
            "label-width": 110,
            model: _vm.edit,
            elem: _vm.editElem,
            rules: _vm.editRule,
            submit: false,
          },
          on: { "on-submit": _vm.toSubmit },
        },
        [
          _c(
            "div",
            { attrs: { slot: "extend" }, slot: "extend" },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "名称", prop: "name" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入名称",
                              maxlength: "50",
                            },
                            model: {
                              value: _vm.edit.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "name", $$v)
                              },
                              expression: "edit.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "编码", prop: "code" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入编码",
                              maxlength: "50",
                            },
                            model: {
                              value: _vm.edit.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "code", $$v)
                              },
                              expression: "edit.code",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "类型", prop: "type" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.edit.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "type", $$v)
                                },
                                expression: "edit.type",
                              },
                            },
                            _vm._l(_vm.enums.lisTypes, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "价格", prop: "price" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入价格",
                              maxlength: "10",
                            },
                            model: {
                              value: _vm.edit.price,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "price", $$v)
                              },
                              expression: "edit.price",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "抽血试管", prop: "bloodTubeId" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.edit.bloodTubeId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "bloodTubeId", $$v)
                                },
                                expression: "edit.bloodTubeId",
                              },
                            },
                            _vm._l(_vm.bloodTubeList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "金域标本子码", prop: "subCode" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入金域标本子码",
                              maxlength: "50",
                            },
                            model: {
                              value: _vm.edit.subCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "subCode", $$v)
                              },
                              expression: "edit.subCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "状态", prop: "status" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.edit.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "status", $$v)
                                },
                                expression: "edit.status",
                              },
                            },
                            _vm._l(_vm.enums.status, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "备注", prop: "remark" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入备注",
                              rows: 3,
                            },
                            model: {
                              value: _vm.edit.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "remark", $$v)
                              },
                              expression: "edit.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "项目告知书" } },
                        [
                          _c(
                            "el-upload",
                            {
                              class: { hideUpload: _vm.hideUpload },
                              attrs: {
                                action: "#",
                                limit: 1,
                                "file-list": _vm.fileList,
                                "list-type": "picture-card",
                                "auto-upload": false,
                                "on-change": _vm.handleChange,
                                "on-preview": _vm.handlePreview,
                                "on-remove": _vm.handleRemove,
                                "before-upload": _vm.beforeAvatarUpload,
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "el-upload__tip",
                                  attrs: { slot: "tip" },
                                  slot: "tip",
                                },
                                [
                                  _vm._v(
                                    "只能上传png/jpg/jpeg文件，且大小不超过500MB"
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "Modal",
                            {
                              attrs: {
                                width: "50%",
                                title: "预览",
                                styles: { top: "60px" },
                                footerHide: true,
                              },
                              model: {
                                value: _vm.dialogVisible,
                                callback: function ($$v) {
                                  _vm.dialogVisible = $$v
                                },
                                expression: "dialogVisible",
                              },
                            },
                            [
                              _c("img", {
                                staticStyle: {
                                  display: "block",
                                  "max-width": "100%",
                                  margin: "0px auto",
                                },
                                attrs: { src: _vm.dialogImageUrl },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }